import { render } from "./SignupForm.component.vue?vue&type=template&id=76aae82b&scoped=true"
import script from "./SignupForm.component.vue?vue&type=script&lang=js"
export * from "./SignupForm.component.vue?vue&type=script&lang=js"

import "./SignupForm.component.vue?vue&type=style&index=0&id=76aae82b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76aae82b"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField,QBtn});
